<script setup lang="ts">

const props = defineProps<{
  messageError: string,
  codeError: string
}>()

const handleError = () => clearError({redirect: useNuxtApp().$localePath({name: 'index'})})
</script>

<template>
  <div class="grow rounded-bento bg-white flex items-center justify-center">
    <div class="relative my-6 max-w-sm mx-auto">
      <img src="/assets/images/demo/error.png" alt="" class="rounded-[1.5rem]" />
      <div class="absolute inset-0 flex flex-col text-center p-6">
        <div class="text-white font-bold text-[140%] text-balance">{{ messageError }}</div>
        <div class="grow text-white opacity-35">{{ codeError }}</div>
        <div>
          <AtomsButton :label="$t('_global.back')" @click="handleError" hover-scheme="border-light" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>